// File: HeroAboutReactComponent.jsx
// Usage: paste this file into a React app (Create React App / Vite).
// It uses pure CSS included below. Two image sources: one uses the uploaded screenshot path and two use picsum placeholders.

import { Lightbulb, MapPinHouse, Stars } from 'lucide-react';
import React from 'react';


export default function AboutUsCard1() {
  return (<>
    <div className="ha-wrap card-ac-1">
    

      <section className="ha-hero">
        <div className="ha-left">
          <div className="ha-top-image ">
            <img src="https://picsum.photos/520/320?random=4" alt="dummy" />
          </div>

          <div className="ha-badge"> 
            <div className="icon-ac-1"><Stars size={20} color={`#fff`} /></div>
            <div>
              <strong>Secure Your Home</strong>
              <p className="small-ac-1">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            </div>
          </div>

          <div className="ha-bottom-row">
            <div className="card-ac-1">
              <img src="https://picsum.photos/520/320?random=2" alt="room" />
            </div>

            <div className="card-ac-1">
              <img src="https://picsum.photos/420/320?random=3" alt="device" />
            </div>
          </div>
        </div>

        <div className="ha-right glass-ac-1">
          <div className="tag">About Us</div>
          <h2>About Us</h2>
          <p className="lead-ac-1">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>

          <div className="feature-ac-1s">
            <div className="feature-ac-1">
              <div className="ficon-ac-1"><Lightbulb size={20} color={`#fff`} /></div>
              <div>
                <strong>Professional Service</strong>
                <p className="small-ac-1">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>

            <div className="feature-ac-1">
              <div className="ficon-ac-1"><MapPinHouse size={20} color={`#fff`} /></div>
              <div>
                <strong>100% Service Guarantee</strong>
                <p className="small-ac-1">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>

          <button className="ha-btn">Explore More →</button>
        </div>
      </section>

    </div>
    <style>{`
/* File: HeroAbout.css */

:root{
  --blue-1: #06283d;
  --blue-2: rgba(144, 202, 249,1);
  --glass-ac-1: rgba(144, 202, 249,0.51);
  --accent: #1790ff;
}


.ha-wrap{ display:flex; flex-direction:column;margin-top:50px;}

/* Header */
.ha-header{display:flex; align-items:center; justify-content:space-between; padding:20px 40px;}
.ha-logo{font-weight:700; background:#0b3b70; padding:8px 12px; border-radius:6px}
.ha-logo span{display:block; font-weight:500; font-size:12px; opacity:0.9}
.ha-nav a{margin-left:18px; color:var(--accent); cursor:pointer}
.ha-nav a.ha-cta{background:var(--accent); color:#fff; padding:8px 12px; border-radius:8px}

/* Hero layout */
.ha-hero{display:flex; gap:28px; padding:38px; align-items:flex-start; flex:1}
.ha-left{flex:1.05; display:flex; flex-direction:column; gap:18px}
.ha-right{flex:0.95; min-width:420px; padding:28px;}

/* Cards */
.card-ac-1{background:rgba(144, 202, 249,0.21); border-radius:20px; padding:12px; box-shadow:0 8px 30px rgba(2,6,23,0.07);}
.card-ac-1 img{display:block; width:100%; height:100%; object-fit:cover; border-radius:12px}

.ha-top-image{height:220px; border-radius:22px; overflow:hidden}

.ha-badge{display:flex; align-items:flex-start; gap:12px; background:linear-gradient(180deg, rgba(23,144,255,0.12), rgba(23,144,255,0.06)); border-radius:12px; padding:14px; width:260px}
.ha-badge .icon-ac-1{font-size:28px; background:#0b72b9; padding:8px 12px; border-radius:10px}
.ha-badge strong{display:block}
.ha-badge .small-ac-1{font-size:12px; opacity:0.9; margin:6px 0 0}

.ha-bottom-row{display:flex; gap:18px}
.ha-bottom-row .card-ac-1{flex:1; height:220px}

/* Glass panel */
.glass-ac-1{background: rgba(144, 202, 249,0.61); border-radius:22px; backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); border:1px solid rgba(255,255,255,0.04);}
.glass-ac-1 .tag{display:inline-block; background:var(--accent); color:#fff; padding:6px 10px; border-radius:8px; font-size:13px}
.glass-ac-1 h2{font-size:34px; margin:10px 0 12px}
.glass-ac-1 .lead-ac-1{color:rgba(35, 36, 39, 0.9); line-height:1.6}

.feature-ac-1s{display:flex; gap:18px; margin-top:18px}
.feature-ac-1{display:flex; gap:12px; align-items:flex-start; flex:1}
.ficon-ac-1{display:flex; align-items:center; justify-content:center; border-radius:10px; background:rgba(144, 202, 249,1);padding:8px 12px; }
.feature-ac-1 .small-ac-1{font-size:13px; margin:6px 0 0; opacity:0.9}

.ha-btn{margin-top:20px; background:var(--accent); color:#fff; border:0; padding:12px 18px; border-radius:10px; cursor:pointer}

/* Footer */
.ha-footer{text-align:center; padding:18px; opacity:0.6}

/* Responsive */
@media (max-width:980px){
  .ha-hero{flex-direction:column}
  
.ha-hero{ padding:2px; }
  .ha-right{min-width:unset}
}
`}</style>
    </>
  );
}

